import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function SolutionSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-[#050a1a] py-4 md:py-6 px-3 relative" data-id="element-150">
      <div className="absolute top-0 right-0 w-64 h-64 bg-[#8b5cf6] rounded-full blur-[120px] opacity-10 pointer-events-none" data-id="element-151"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-152">
        <div className="inline-block bg-[#eab308]/20 border border-[#eab308]/50 text-[#eab308] font-black px-4 py-1 rounded-full mb-2 uppercase tracking-widest text-xs glow-yellow" data-id="element-153">
          💡 SOLUCIÓN
        </div>

        <h2 className="text-2xl md:text-4xl font-black text-white mb-2" data-id="element-154">
          🎹 KIT COMPLETO{' '}
          <span className="text-[#2563eb] text-glow-blue" data-id="element-155">TECLADO LISTO</span>
        </h2>

        <p className="text-sm md:text-lg text-gray-300 mb-4 max-w-xl mx-auto" data-id="element-156">
          Un sistema completo para dejar de pensar tus clases y empezar a
          ejecutarlas.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-2 max-w-2xl mx-auto mb-4 text-left" data-id="element-157">
          {['6 tomos (360 págs)', 'Clases listas', 'Ejercicios progresivos', 'Evaluaciones', 'Repertorio'].map((item, i) => <div key={i} className="flex items-center gap-2 bg-[#0a1128] border border-[#1e293b] p-2 rounded-lg" data-id="element-158">
              <CheckCircle2 className="w-4 h-4 text-[#2563eb] flex-shrink-0" data-id="element-159" />
              <span className="text-white font-bold text-xs md:text-sm" data-id="element-160">
                {item}
              </span>
            </div>)}
        </div>

        <p className="text-[#eab308] font-bold text-base md:text-lg mb-4" data-id="element-161">
          👉 Todo organizado para que solo tengas que enseñar.
        </p>

        <CTAButton onClick={scrollToPricing} variant="secondary" className="px-6 py-3 text-sm" data-id="element-162">
          VER OPCIONES DE COMPRA
        </CTAButton>
      </div>
    </section>;
}